import React, { useState } from "react";
import { supabase } from "../api/supabase";

const AuthPanel = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignUp, setIsSignUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");

    try {
      if (isSignUp) {
        const { error: signUpError } = await supabase.auth.signUp({
          email,
          password,
        });
        if (signUpError) throw signUpError;
      } else {
        const { error: signInError } = await supabase.auth.signInWithPassword({
          email,
          password,
        });
        if (signInError) throw signInError;
      }
    } catch (err) {
      if (process.env.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.error("Auth error:", err.message);
      }
      setError("Authentication failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-canvas">
      <div className="absolute inset-x-0 top-0 h-2 bg-gradient-to-r from-navy-700 via-navy-600 to-rust-500" />

      <div className="flex min-h-screen items-center justify-center px-6">
        <div className="w-full max-w-md">
          <div className="mb-8 flex items-baseline gap-2">
            <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500">
              Timeline
            </span>
            <span className="font-mono text-[11px] text-zinc-400">/</span>
            <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-rust-600">
              DPR
            </span>
          </div>

          <h1 className="mb-1 text-2xl font-semibold text-zinc-900">
            {isSignUp ? "Create account" : "Sign in"}
          </h1>
          <p className="mb-8 text-sm text-zinc-500">
            {isSignUp
              ? "Set up access to your timeline workspace."
              : "Welcome back. Sign in to continue."}
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="field">
              <label className="label" htmlFor="email">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input"
                required
                autoComplete="email"
              />
            </div>

            <div className="field">
              <label className="label" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input"
                required
                autoComplete={isSignUp ? "new-password" : "current-password"}
              />
            </div>

            {error && (
              <p className="rounded-md border border-rust-200 bg-rust-50 px-3 py-2 text-sm text-rust-700">
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full"
            >
              {loading
                ? "Working…"
                : isSignUp
                ? "Create account"
                : "Sign in"}
            </button>

            <button
              type="button"
              onClick={() => setIsSignUp(!isSignUp)}
              className="block w-full text-center text-sm text-zinc-500 hover:text-zinc-700"
            >
              {isSignUp
                ? "Already have an account? Sign in"
                : "Need an account? Sign up"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AuthPanel;
